<form class="d-flex" tabindex="-1">
  <div class="{{datepickerStyle}}">
    <div class="input-group {{datepickerStyle}}">
      <input #myInput
             [id]="inputId"
             type="text"
             class="{{hasError && submitted ? 'has-error is-invalid' : hasError ? 'invisible-error' : ''}} custom-form-component form-control"
             [placeholder]="placeholder || 'dd.mm.yyyy.'"
             [ngbTooltip]="selectedDatesTitle"
             [disableTooltip]="!selectedDatesTitle"
             tooltipClass="multi-date-tooltip"
             container="body"
             placement="top"
             tabindex="0"
             >
      <div class="input-group-append">
        <button class="btn btn-outline-secondary fa fa-calendar {{hasError && submitted ? 'has-error' : ''}}"
                type="button"
                (click)="open()">
          <i></i>
        </button>
      </div>
    </div>
  </div>
</form>
